import request from '@/utils/axios.js'

const baseUrl = ''
// 查询申请状态
export function applyCardState (data) {
  return request({
    url: baseUrl + '/manageMarket/mobileAPI/creditCard/cardApply',
    method: 'post',
    data: data
  })
}

// 券列表
export function listCoupon (data) {
  return request({
    url: baseUrl + '/manageMarket/mobileAPI/creditCard/activityApplyQry',
    method: 'post',
    data: data
  })
}

// 领券
export function getCoupon (data) {
  return request({
    url: baseUrl + '/manageMarket/mobileAPI/creditCard/activityApply',
    method: 'post',
    data: data
  })
}
